import React, { Component } from "react";
import PropTypes from "prop-types";

class WidgetGizmo extends Component {
  constructor(props, context) {
    super(props, context);
    this.onMouseDown = this.onMouseDown.bind(this);
  }

  onMouseDown(event) {
    const { onMouseDown } = this.props;
    if (onMouseDown) {
      onMouseDown(event, this.props.index);
    }
  }

  render() {
    var size = "100px";
    if (this.props.object.type == "info_window") {
      size = this.props.object.icon_width;
    } else if (this.props.object.type == "portal") {
      size = this.props.object.size;
    }
    size = parseFloat(size) * 1.2 + "px";
    var corner = parseFloat(size) * 0.1 + "px";
    return (
      <div
        style={{
          width: size,
          height: size,
          WebkitTransform: "translate(-50%, -50%)",
          MozTransform: "translate(-50%, -50%)",
          OTransform: "translate(-50%, -50%)",
          transform: "translate(-50%, -50%)",
          border: "solid 4px rgba(181, 242, 212, 0.75)",
          backfaceVisibility: "none",
          borderRadius: corner
        }}
      >
        <span
          onMouseDown={this.onMouseDown}
          className="icon-hand"
          style={{
            cursor: "move",
            WebkitTransform: "translate(-50%, -50%)",
            MozTransform: "translate(-50%, -50%)",
            OTransform: "translate(-50%, -50%)",
            transform: "translate(-50%, -50%)",
            position: "absolute",
            display: "block",
            width: "50px",
            height: "50px",
            backgroundColor: "rgb(45, 228, 136)",
            borderRadius: "50px",
            color: "rgb(72, 97, 102)",
            fontSize: "40px",
            lineHeight: "50px"
          }}
        />
      </div>
    );
  }
}

export default WidgetGizmo;



// WEBPACK FOOTER //
// ./src/components/Player/WidgetGizmo/WidgetGizmo.js